import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/native'

import { AIConversationToggleRow, AIConversationToggleRowItem } from '../../../molecules/aiCoachToggle/AICoachToggle'
import { ClientDetailsSidePanelSection } from '../ClientDetailsSidePanelSection'

export type AIConversationsSidePanelSectionProps = {
  rows: AIConversationToggleRow[]
}

const Container = styled.View({
  zIndex: 1,
})

const Rows = styled.View(({ theme }) => ({
  gap: theme.spacing['8px'],
}))

export const AIConversationsSidePanelSection: FunctionComponent<AIConversationsSidePanelSectionProps> = ({ rows }) => {
  const { formatMessage } = useIntl()

  if (rows.length === 0) {
    return null
  }

  const subtitle = formatMessage({
    defaultMessage: 'Conversations with Lyra AI',
    description:
      'Subtitle for the client details side-panel section where providers turn Lyra AI conversations on or off',
  })

  return (
    <Container>
      <ClientDetailsSidePanelSection
        subtitle={subtitle}
        accessibilityName={subtitle}
        header={{ kind: 'static' }}
        content={
          <Rows>
            {rows.map((row, index) => (
              <AIConversationToggleRowItem key={row.id} row={row} zIndex={rows.length - index} />
            ))}
          </Rows>
        }
        testIDPrefix='AIConversations'
      />
    </Container>
  )
}
